import { cn } from "@/lib/utils";
import { ButtonProps } from "@radix-ui/themes";
import { PropsWithChildren } from "react";
import { Link as RouterDomLink } from "react-router-dom";

// Workaround to create link which look like radix button
export function Link({
  to,
  openInNewTab = false,
  color = "gray",
  size = "2",
  variant = "solid",
  highContrast = true,
  children,
}: PropsWithChildren<ButtonProps & { to: string; openInNewTab?: boolean }>) {
  return (
    <a
      href={to}
      {...(openInNewTab && { target: "_blank", rel: "noreferrer" })}
      data-accent-color={color}
      className={`rt-reset rt-BaseButton rt-r-size-${size} rt-variant-${variant} ${
        highContrast ? "rt-high-contrast" : ""
      } rt-Button`}
    >
      {children}
    </a>
  );
}

export function RouterLink({
  to,
  openInNewTab = false,
  color = "gray",
  size = "2",
  variant = "solid",
  highContrast = true,
  replace = false,
  className,
  children,
}: PropsWithChildren<
  ButtonProps & { to: string; openInNewTab?: boolean; replace?: boolean }
>) {
  return (
    <RouterDomLink
      to={to}
      {...(openInNewTab && { target: "_blank", rel: "noreferrer" })}
      data-accent-color={color}
      className={cn(
        `rt-reset rt-BaseButton rt-r-size-${size} rt-variant-${variant} rt-Button`,
        highContrast && "rt-high-contrast",
        className
      )}
      replace={replace}
    >
      {children}
    </RouterDomLink>
  );
}
